import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { CorporateService } from '../../_service/corporate.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import { LeadsService } from '../../_service/leads.service';
import { UserService } from '../../_service/user.service';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-corporate-lead-add-edit',
  templateUrl: './corporate-lead-add-edit.component.html',
  styleUrls: ['./corporate-lead-add-edit.component.css']
})
export class CorporateLeadAddEditComponent implements OnInit {
  myrole:string;userId:string;CorporateLeadForm: FormGroup;loading:boolean=false;submitted:boolean=false;corporateLeadId:any;circles=[];usersList:any=[];corporate_lead_status=[];
  constructor(private userapi:UserService,private leadapi:LeadsService,private corporateapi:CorporateService, private sharedapi:SharedService,private formBuilder: FormBuilder,private route:ActivatedRoute, private router: Router,private activatedRoute: ActivatedRoute, private elem: ElementRef) { 
    let contactPattern = "[[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*]*";
    let vaildEmailAddress: any = "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@" + "[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$";
    this.CorporateLeadForm = this.formBuilder.group({ 
      'company_name' : [null, Validators.required],
      'company_contact_number' : [null, Validators.compose([Validators.required, Validators.pattern(contactPattern)])],
      'company_email' : [null, Validators.compose([Validators.required, Validators.pattern(vaildEmailAddress)])],
      'status': [null, Validators.required],
      'number_of_employee':[null],
      'client_name' : [null, Validators.required],
      'circle_id':[null, Validators.required],
      'user_id':[null, Validators.required],
      'description':[null],
      'designation':[null],
      'incorporate_licence':[null],
      'cover_type':[null],
      'policy_type':[null],
      'sum_insured':[null],
      'renew_date':[null]
    });
  }
  get f() { return this.CorporateLeadForm.controls; }
  ngOnInit(): void {
    this.sharedapi.getRole();
    this.getcircle();
    this.getcorporateUser();
    this.getCorporateStatusLists();
    this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
    this.myrole = localStorage.getItem('role');
    this.userId = localStorage.getItem('loginuserId');

    this.corporateLeadId = this.route.snapshot.paramMap.get("corporate_lead_id");
    if(this.corporateLeadId)
    {
      this.getCorporateLeadFormData();
    }
  }

  async getCorporateStatusLists()
  {
    await this.corporateapi.getCorporateStatusLists().subscribe((data:any) => {
      if(data.status)
      {
        this.corporate_lead_status = data.data;
      }
      else
      {
        this.corporate_lead_status = [];
      }
    }, error => {
      this.sharedapi.checkError(error);
    });
  }

  async getcorporateUser()
    {
        this.userapi.getUserByRole('14').subscribe((data:any) => {
            if(data.status)
            {
                this.usersList = data.data;
            }else{
                this.usersList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

  async getcircle()
    {
        this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

  getCorporateLeadFormData(){
    this.corporateapi.getCorporateLeadFormData(this.corporateLeadId).subscribe((data:any) => {
      if(data.status){
        this.CorporateLeadForm.patchValue({
          'company_name':data.data.company_name,
          'company_contact_number':data.data.company_contact_number,
          'company_email':data.data.company_email,
          'status':data.data.status,
          'number_of_employee':data.data.number_of_employee,
          'description':data.data.description,
          'client_name':data.data.client_name,
          'circle_id':data.data.circle_id,
          'user_id':data.data.user_id,
          'designation':data.data.designation,
          'incorporate_licence':data.data.incorporate_licence,
          'cover_type':data.data.cover_type,
          'policy_type':data.data.policy_type,
          'sum_insured':data.data.sum_insured,
          'renew_date':new Date(data.data.renew_date*1000),
          
        });
      }else{
        this.CorporateLeadForm.patchValue({
          'company_name':'',
          'company_contact_number':'',
          'company_email':'',
          'status':'',
          'number_of_employee':'',
          'description':'',
          'client_name':'',
          'circle_id':'',
          'user_id':'',
          'designation':'',
          'incorporate_licence':'',
          'cover_type':'',
          'policy_type':'',
          'sum_insured':'',
          'renew_date':'',
        });
        this.sharedapi.presentToast(data.msg);
      }
    }, error => {
          this.sharedapi.checkError(error);
    });
  }

  submitCorporateLead()
  {
    this.submitted = true;
    this.loading = true;
    // stop here if form is invalid
    if(this.CorporateLeadForm.invalid) {
        this.loading = false;
        return;
    }
    if(this.corporateLeadId && this.corporateLeadId!='0'){
      this.CorporateLeadForm.value.id= this.corporateLeadId;
    } 
    this.corporateapi.addCorporateLead(this.CorporateLeadForm.value)
      .subscribe((data:any) => {
        this.submitted = false;
        this.loading = false;
        if(data.status)
        {
          this.sharedapi.presentToast(data.msg);
          setTimeout(() => {
            this.router.navigate(["update-corporate-lead/"+data.last_id]);
          }, 2000);
        }
        else
        {
          this.sharedapi.presentToast(data.msg);
        }
      }, error => 
      {
          this.sharedapi.checkError(error);
      });
  }

}
